/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  ViewChild,
  ViewChildren,
  QueryList,
  AfterViewInit
}                            from '@angular/core';

import { Scenario          } from '@/models/scenario/scenario';
import { Logger            } from '@/util/logger';
import {
  basename,
  empty
} from '@/util/util';

import { ThreeStringViewer } from '@/screens/ide/stringviewer/three.string.viewer';

import * as $ from 'jquery';

import 'gasparesganga-jquery-loading-overlay'; /* https://gasparesganga.com/labs/jquery-loading-overlay/ */

import {UserLogService} from "@/services/user.log.service";
import {first} from "rxjs/operators";

@Component({
  selector: 'string-viewer-component',
  template: `

    <!-- the scenario loader drop down -->
    <div class="sv-loader-wrapper" (click)="$event.stopPropagation();">

      <div
        class="sv-expander"
        (click)="toggleLoader()"
        [innerHTML]="expanderElement"
        title="Select Scenario/Movement">
      </div>

      <div
        class="sv-loader-panel"
        [class.expanded]="loaderActive">

        <div
          id="sv-scenario-form-drop-area_{{u}}"
          class="drop-area sv-drop-area">

            <p>To select a new scenario, drop a scenario on this dashed area, or click Browse.</p>
            <input
              (change)="onScenarioFileBrowse($event.target.files); $event.stopPropagation(); false"
              type="file" id="sv-scenario-upload_{{u}}"
              style="display: none !important;">

          <div>
            <label
              class="gui-button primary"
              style="display: inline-block;"
              for="sv-scenario-upload_{{u}}"
              (click)="browseScenarioClick($event); $event.stopPropagation(); false">
              Browse
            </label>
            <span [innerHTML]="scenarioBaseName" style="margin-left: 8px; display: inline-block;"></span>
          </div>

        </div>

        <div
          id="sv-movement-form-drop-area_{{u}}"
          class="drop-area sv-drop-area">

          <p>To select a new movement, drop a movement (simulation result) on this dashed area, or click Browse.</p>
          <input
            (change)="onMovementFileBrowse($event.target.files); $event.stopPropagation(); false"
            type="file" id="sv-movement-upload_{{u}}"
            style="display: none !important;">

          <div>
            <label
              class="gui-button primary"
              for="sv-movement-upload_{{u}}"
              style="display: inline-block;"
              (click)="browseMovementClick($event); $event.stopPropagation(); false">
              Browse
            </label>
            <span [innerHTML]="movementBaseName" style="margin-left: 8px; display: inline-block;"></span>
          </div>

        </div>

        <div class="sv-scenario-name">
          <span class="sv-scenario-label">Scenario:</span>
          <span class="sv-scenario-title" [innerHTML]="scenarioTitle"></span>
        </div>

        <div class="sv-movement-name">
          <span class="sv-movement-label">Movement:</span>
          <span class="sv-movement-title" [innerHTML]="movementTitle"></span>
        </div>

        <div *ngIf="errorLine!==''" class="sv-scenario-error" [innerHTML]="errorLine">
        </div>

      </div>

      <div
        class="sv-help-expander"
        (click)="toggleHelp()"
        [innerHTML]="helpElement"
        title="Help &amp; Key Bindings">
      </div>

      <div
        class="sv-help-panel"
        [class.expanded]="helpActive">

        <h5 style="margin-top: 36px; color: #ffffff;">Navigation Control</h5>

        <p style="color: #ffffff;">All navigation features are accessible via point and click.  You may also hover the mouse over items
          for quick help.  For faster access, use the key bindings below.  To change your keyboard input focus to
          the viewer, click on the viewer area.</p>

        <table class="table" style="width: 100%; color: #ffffff;">
          <thead>
          <tr>
            <th style="width: 100px;">Key</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>

          <tr>
            <td>
              <code>DRAG</code>
            </td>
            <td>
              Click dragging with the <code>LEFT MOUSE</code> button will pan the main view.  This does not
              change your current zoom level or the X/Y scaling of the graph.  Graph will move 1:1 with your
              dragging movement.
            </td>
          </tr>

          <tr>
            <td>
              <code>WHEEL UP</code>
            </td>
            <td>
              Context sensitive; if you wheel up over the main view then the view will zoom in.  If you are
              hovering over the Y axis (distance) it will scale up the graph vertically without altering
              your zoom level.  Similarly if you wheel up while hovering over the X axis (time), it will
              scale up the graph horizontally.  If you become unsure of your position, simply use the auto-fit
              button in the command bar (top of view) to see the whole graph in its current aspect ratio.

              The axis will glow with a blue border when it is taking the wheel events.  You can also use the
              <code>CTRL-UP</code> arrow key when the main view has the keyboard focus (click to take
              focus), to scale up the Y axis.  Use the other arrows keys for the various kinds of scaling.
            </td>
          </tr>

          <tr>
            <td>
              <code>WHEEL DOWN</code>
            </td>
            <td>
              Context sensitive; if you wheel down over the main view then the view will zoom out.  If you are
              hovering over the Y axis (distance) it will scale down the graph vertically without altering
              your zoom level.  Similarly if you wheel down while hovering over the X axis (time), it will
              scale up the graph horizontally.  If you become unsure of your position, simply use the auto-fit
              button in the command bar (top of view) to see the whole graph in its current aspect ratio.

              The axis will glow with a blue border when it is taking the wheel events.  You can also use the
              <code>CTRL-DOWN</code> arrow key when the main view has the keyboard focus (click to take
              focus), to scale down the Y axis.  Use the other arrows keys for the various kinds of scaling.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-UP</code>
            </td>
            <td>
              Scale up vertical axis, independently of your zoom level.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-DOWN</code>
            </td>
            <td>
              Scale down vertical axis, independently of your zoom level.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-LEFT</code>
            </td>
            <td>
              Scale down horizontal axis, independently of your zoom level.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-RIGHT</code>
            </td>
            <td>
              Scale up horizontal axis, independently of your zoom level.
            </td>
          </tr>

          <tr>
            <td>
              <code>RIGHT MOUSE</code>
            </td>
            <td>
              Popup the context menu, from here you have access to additional features such as switching
              from dark to light mode.  If there is a train movement under the mouse, you have access to
              additional actions such as the Delay Report.
            </td>
          </tr>

          <tr>
            <td>
              <code>LEFT MOUSE</code>
            </td>
            <td>
              Clear the existing selection group and make this train the selection, if there is a train under
              the mouse.  You can use <code>CTRL + LEFT MOUSE</code> to append to the selection group.  Note that
              the selection group is independent of the search matches (if any).  You can have selection and
              search matches at the same time.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL + LEFT MOUSE</code>
            </td>
            <td>
              Append a train (if under the mouse) to the existing selection group.  Does not clear the existing
              selection and does not alter the search matches if any.
            </td>
          </tr>

          <tr>
            <td>
              <code>F11</code>
            </td>
            <td>
              Toggle full screen mode. Note that you must have loaded a scenario first.  Click the viewer
              window to ensure it has the input focus, if F11 is defaulting to the browser action rather than
              full screen mode.  You can also <code>RIGHT MOUSE</code>, and select Show Full Screen.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-C</code>
            </td>
            <td>
              Switch color modes, only two modes currently; Train and Track.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-V</code>
            </td>
            <td>
              Switch HUD display from simple to full and back.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-D</code>
            </td>
            <td>
              Switch between dark and light mode.  In light mode, background is white, suitable for printing.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-F</code>
            </td>
            <td>
              Open the search input (command bar, at the top).  Start typing the name of a train and auto-complete
              will allow you to select a series of trains to highlight.  At any time you can use <code>F3</code>
              and <code>SHIFT+F3</code> to quickly jump from match to match.
            </td>
          </tr>

          <tr>
            <td>
              <code>F3</code>
            </td>
            <td>
              You can use <code>F3</code> and <code>SHIFT+F3</code> to quickly jump from match to match.  If
              not already open, the search matches panel will automatically open.  The current match is
              highlighted and will be visible in the results list.  To randomly jump to a search match, click
              on the match to focus the viewer on.  The viewer will show the first few moves of that train.
            </td>
          </tr>

          <tr>
            <td>
              <code>CTRL-S</code>
            </td>
            <td>
              Open the selection group panel.  From here you can view the trains currently selected. To focus the
              viewer on a selection, simply click on it.  You can use <code>TAB</code> and <code>SHIFT+TAB</code>
              to quickly jump from item to item in your selection group.  You do not have to open the selection
              group panel to tab through the selection items.  It will automatically open if not already open.
            </td>
          </tr>

          <tr>
            <td>
              <code>TAB</code>
            </td>
            <td>
              You can use <code>TAB</code> and <code>SHIFT+TAB</code> to quickly jump from item to item in
              the current selection group. If not already open, the selection group panel will automatically
              open.  The currently focused selection item, will be highlighted. To randomly jump to a selection
              item, click on it in the selection group panel, and the viewer will refocus.
            </td>
          </tr>

          </tbody>
        </table>

      </div>

    </div>

    <!-- outer shell for the  browser tabs -->
    <div class="string-viewer-shell" style="text-align:center">
      <three-string-viewer uuid={{u}} id="tsv_{{u}}"></three-string-viewer>
    </div>
  `
})

export class StringViewerComponent implements AfterViewInit {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum: number = 0;
  public u: number = StringViewerComponent.instanceNum;

  public    loaderActive: boolean  = false;

  public      helpActive: boolean  = false;

  /** hint for window title, whatever we have for the basename of the scenario file */
  public        fileName: string   = '';

  /* the content to show for the expand collapse button */
  public expanderElement: string   = '<i class="fas fa-angle-down"></i>';

  /* the content to show for the help collapse button */
  public helpElement: string       = '<i class="far fa-question-circle"></i>';

  /* the visible name of the scenario being browsed */
  public   scenarioTitle: string   = '';

  /* the visible name of the movement being browsed */
  public   movementTitle: string   = '';

  /* base name of the file being used to load scenario */
  public scenarioBaseName: string = '';

  /* base name of the file being used to load movement */
  public movementBaseName: string = '';

  /* the object (reconstructed from JSON) for the scenario (pending) */
  public           input: any      = null;

  /* the object (reconstructed from JSON) for the train movements (pending) */
  public          output: any      = null;

  /* the error feedback if required */
  public       errorLine: string   = '';

  /* the current scenario model (most have both scenario  and movement) */
  public       scenario: Scenario = null;

  @ViewChild(ThreeStringViewer,  {static: false})
  public viewer: ThreeStringViewer;

  /* general call back for when we reload */

  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private userlogs: UserLogService
  ) {


    Logger.debug('[stringviewer] dynamically creating...');

  }

  ngAfterViewInit(): void {

    /* - - - - - -  add in drag n' drop behaviors */

    /* get the scenario drop box */
    const          u: number = StringViewerComponent.instanceNum;
    const instanceId: string = `tsv_${this.u}`;

    Logger.debug(`[stringviewer] setting up drop zone, instance id=${instanceId}...`);

    /* before we can do anything we need to establish which viewer is for this component ... */

    if (!this.viewer) {

      Logger.error(`[stringviewer] can't connect to view viewer for this instance (${u}).`);

    } else {

      Logger.debug(`[stringviewer] instance ${u} connected to viewer:`, this.viewer);
    }

    let dropArea: HTMLElement = $(`#sv-scenario-form-drop-area_${u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(`#sv-scenario-form-drop-area_${u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(`#sv-scenario-form-drop-area_${u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onScenarioFileBrowse(Array.from(dt.files));

    }, false);

    /*  ... and for the movement */

    dropArea = $(`#sv-movement-form-drop-area_${u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(`#sv-movement-form-drop-area_${u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, () => {

        $(`#sv-movement-form-drop-area_${u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onMovementFileBrowse(Array.from(dt.files));

    }, false);

    StringViewerComponent.instanceNum++;

  }

  /** clean up when closing the window */
  public close() {

    if (this.viewer === null) {

      return ;
    }

    Logger.debug('[stringviewer] component is closing.');

    this.viewer.close();
  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseScenarioClick(e: MouseEvent) {

    document.getElementById(`sv-scenario-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseMovementClick(e: MouseEvent) {

    document.getElementById(`sv-movement-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** StatusReporter */
  status(text: string): void {

    this.errorLine = `<i class="wbedit-info-line">${text}</i>`;

    Logger.info(`[stringviewer] ${text}`);
  }

  /** @brief publish an error message */
  error(text: string): void {

    this.errorLine = `<i class="wbedit-error-line">${text}</i>`;

    Logger.error(`[stringviewer] ${text}`);
  }

  /** @brief publish a success message */
  success(text: string): void {

    this.errorLine = `<i class="wbedit-success-line">${text}</i>`;

    Logger.info(`[stringviewer] ${text}`);
  }

  /** react to the user browsing a local windows scenario file */
  public onScenarioFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File    = files[0];
    const fName: string   = basename(upload.name);

    Logger.debug('[stringviewer] setting scenario via file: ', upload);

    this.errorLine        = '';
    this.scenarioBaseName = fName;
    this.fileName         = fName;

    /* read in the raw text */

    const reader   = new FileReader();
    const sv       = this;

    reader.onerror = (msg) => {

      sv.status('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      /* we have the text try to convert to an object if we can */

      try {

        sv.input = JSON.parse(String(text));

      } catch (e) {

        sv.scenarioBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('Can not parse scenario JSON: ' + e);
        this.status('Can not parse scenario JSON: ' + e);

        return ;
      }

      if (this.input === null || this.input === undefined || this.input === '') {

        sv.scenarioBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('Can not parse movement JSON.');
        sv.status('Can not parse movement JSON.');

        return ;
      }

      /* before we try to sync, check to see if it even looks reasonable. */

      const value = this.input?.scenario?.meta?.data;

      if (value === undefined) {

        sv.scenarioBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('scenario file is parsable, but doesn\'t look like a scenario.');
        sv.status('scenario file is parsable, but doesn\'t look like a scenario.');

        sv.input = null;

        return ;
      }

      /* ok, we have a new input...if we also have a new output, time to update the viewer... */

      sv.sync();
    };

    reader.readAsText(upload);
  }

  /** react to the user browsing a local windows movement (simulation results) file */
  public onMovementFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File    = files[0];
    const fName: string   = basename(upload.name);

    this.movementBaseName = fName;

    Logger.debug('[stringviewer] setting movement via file: ', upload);

    this.status('');

    /* read in the raw text */

    const reader   = new FileReader();
    const sv       = this;

    reader.onerror = (msg) => {

      sv.status('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      /* we have the text try to convert to an object if we can */

      try {

        sv.output = JSON.parse(String(text));

      } catch (e) {

        sv.movementBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('Can not parse movement JSON: ' + e);
        sv.status('Can not parse movement JSON: ' + e);

        return ;
      }

      if (this.output === null || this.output === undefined || this.output === '') {

        sv.movementBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('Can not parse movement JSON.');
        sv.status('Can not parse movement JSON.');

        return ;
      }

      /* before we try to sync, check to see if it even looks reasonable. */

      const value = this.output?.sim_results?.datapoints;

      if (value === undefined) {

        sv.movementBaseName = `<span class="error-text-highlight">${fName}</span>`;

        Logger.error('movement file is parsable, but doesn\'t look like a movement.');
        sv.status('movement file is parsable, but doesn\'t look like a movement.');

        sv.output = null;

        return ;
      }

      /* ok, we have a new output...if we also have a new input, time to update the viewer... */

      sv.sync();
    };

    reader.readAsText(upload);
  }

  /* try to load scenario and movement manually */
  public fromText(scenarioText: string, movementText: string, inputKey: string = '') {

    Logger.debug('[stringviewer] loading from raw text ...');

    this.fileName = '';

    if (!empty(inputKey)) {

      this.fileName = basename(inputKey);
    }

    /* convert to JSON */

    let   input = null;
    let  output = null;

    try {

      input = JSON.parse(scenarioText);

    } catch (e) {

      Logger.error('[stringviewer] Can not parse scenario JSON: ' + e);
      this.status('Can not parse scenario JSON: ' + e);

      return ;
    }

    try {

      output = JSON.parse(movementText);

    } catch (e) {

      Logger.error('[stringviewer] Can not parse movement JSON: ' + e);
      this.status('Can not parse movement JSON: ' + e);

      return ;
    }

    this.input   = input;
    this.output = output;

    this.sync();
  }

  /** tell the Three.js viewer what scenario to use */
  public finalizeView(newScenario: Scenario) {

    const svc: StringViewerComponent = this;

    /* we have everything in an internal data structure, no need for the RAW JSON data now */

    svc.scenarioBaseName = '';
    svc.movementBaseName = '';
    svc.input            = null;
    svc.output           = null;
    svc.scenario         = newScenario;

    svc.updateTitles();

    /* ok, update the graph */

    if (!this.viewer.setScenario(svc.scenario)) {

      const msg: string = 'Could not update graph.';

      svc.error(msg);

      svc.onScenarioUnlock(msg);

      return false ;
    }

    /* if the loader is open, we can close it now...there aren't any errors to show */

    if (svc.loaderActive) {

      svc.toggleLoader();
    }

    /* let the user work again ... */

    svc.onScenarioUnlock('Model loaded and sync\'d.');

    /* tell any users of this viewer that we changed */

    svc.reloaded();
  }

  /* check to see if the pending input/output can be used to make a paired scenario */
  public sync() {

    const svc: StringViewerComponent = this;

    svc.status('');

    Logger.debug('[stringviewer]', 'syncing. input: ', svc.input, 'output:', svc.output);

    if ((svc.input == null) || (svc.output == null)) {

      /* nothing to do (yet) */

      return false;
    }

    Logger.debug('[stringviewer]', 'reconstructing scenario...');

    svc.onScenarioLock('Loading, please wait...');

    /* only update the scenario if we successfully construct a new one */

    const  newScenario  = new Scenario(svc.input, svc.output, svc);

    if (!newScenario.isReady()) {

      const msg: string = 'Could not read plant/movement: ' + newScenario.getError();

      svc.error(msg);

      svc.onScenarioUnlock(msg);

      return false ;
    }

    if (newScenario.hasUserLogging()) {

      /* fetch any pre-loaded user-logging info...and then set the scenario */

      svc.userlogs.preload(newScenario.userLog()).pipe(first())
        .subscribe(
          (data: any) => {

            /* do the pre-loading */

            newScenario.preloadUserLogging(data);

            /* ok, we can finalize the view now */

            svc.finalizeView(newScenario);
          },
          (error) => {

            /* busted. */

            const msg: string = 'Could not update graph: ' + error;

            svc.error(msg);

            svc.onScenarioUnlock(msg);

          });

    } else {

      /* just set the scenario */

      setTimeout( () => {

        svc.finalizeView(newScenario);

      }, 401);

    }

    return true;
  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    Logger.debug('[stringviewer] locking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    Logger.debug('[stringviewer] unlocking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  /** set the scenario using the given JSON */
  public setScenario(s: Scenario) {

    Logger.debug('[stringviewer] setting new scenario...');

    this.input     = null;
    this.output    = null;
    this.scenario  = s;
    this.status('');

    if (s == null) {

      /* clear the graph */

      this.viewer.setScenario(null);

      /* nothing to do, just clearing */

      return ;
    }

    this.updateTitles();

    /* update  the graph */

    this.viewer.setScenario(this.scenario);
  }

  /* update scenario/movement title */
  public updateTitles() {

    this.scenarioTitle = '';
    this.movementTitle = '';

    if (this.scenario == null) {

      return ;
    }

    this.scenarioTitle = this.scenario._tag;
    this.movementTitle = this.scenarioTitle + ' (output) ';
  }

  /** open the scenario loader drop down panel (or close it) */
  public toggleLoader() {

    if (this.loaderActive) {

      /* collapse */

      this.loaderActive    = false;
      this.expanderElement = '<i class="fas fa-angle-down"></i>';

      return ;
    }

    /* expand */

    this.loaderActive    = true;
    this.expanderElement = '<i class="fas fa-angle-up"></i>';
  }

  /** open the help drop down panel (or close it) */
  public toggleHelp() {

    if (this.helpActive) {

      /* collapse */

      this.helpActive    = false;
      this.helpElement = '<i class="far fa-question-circle"></i>';

      return ;
    }

    /* expand */

    this.helpActive    = true;
    this.helpElement = '<i class="fas fa-question-circle"></i>';
  }
}
